import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-redo",
  "use": "icon-redo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-redo\"><path d=\"M853.3 653.4V439.3c0-7.2-8.7-10.7-13.7-5.7l-77.9 77.9C704.6 427.2 601 362.7 469.2 362.7c-192.5 0-294.9 144.8-298.6 290.5-.1 4.5 3.5 8.2 8 8.2H248c4.3 0 7.9-3.5 8-7.8C259.3 553.1 326.3 448 469.2 448c107 0 190.8 56.6 230.5 125.3l-74.3 74.3c-5 5.1-1.4 13.7 5.7 13.7h214.1c4.5 0 8-3.5 8.1-7.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol